import React from 'react';

export interface IPaymentPortalHeader {
  logo?: string;
  bgColor: string;
}

const PaymentPortalHeader: React.FC<IPaymentPortalHeader> = ({ logo, bgColor }) => (
  <header className="payment-portal-home__header" style={{ backgroundColor: bgColor }}>
    {logo && <img src={logo} alt="Agency Logo" />}
  </header>
);

export default PaymentPortalHeader;
